import { ReactComponent as FlagIcon } from "./svg/at-flag.svg";
import "../flag-icon.scss";

export const ATFlag = () => {
  return (
    <span className="flag-icon">
      <FlagIcon />
    </span>
  );
};
